import { render, staticRenderFns } from "./body.vue?vue&type=template&id=34b5607d&scoped=true&"
import script from "./body.vue?vue&type=script&lang=ts&"
export * from "./body.vue?vue&type=script&lang=ts&"
import style0 from "./body.vue?vue&type=style&index=0&id=34b5607d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5607d",
  null
  
)

export default component.exports